export const SET_TENANT_DOMAIN_TYPE = 'SET_TENANT_DOMAIN_TYPE';
export const SET_TENANT_NAME = 'SET_TENANT_NAME';
export const SET_TENANT_BRANDING = 'SET_TENANT_BRANDING';

export const setTenantDomainTypeAction = domainType => ({
  type: SET_TENANT_DOMAIN_TYPE,
  payload: domainType ?? null,
});

export const setTenantNameAction = name => ({
  type: SET_TENANT_NAME,
  payload: name ?? null,
});

export const setTenantBrandingAction = branding => ({
  type: SET_TENANT_BRANDING,
  payload: branding ?? null,
});
